import { getRemotedbUrl } from "./ep";

export const save_stage_ticket = (ticket,promotion_id, cb) => {
	$.post(getRemotedbUrl(`/stages/save_stage_ocr_ticket/${promotion_id}`), {
		ticket:JSON.stringify(ticket),
	}, (response) => {
		if(cb != undefined) cb(response);
	},'JSON');
};

export const reprocess_ticket = (ticket_id,promotion_id, cb) => {
	$.post(getRemotedbUrl(`/stages/reprocess_ticket/${promotion_id}`), {
		ticket_id:ticket_id,
	}, (response) => {
		if(cb != undefined) cb(response);
	},'JSON');
};

export const get_credit = (product_id,cb) => {
	fetch(getRemotedbUrl(`/v24/pack/${product_id}`)).then((r) => r.json()).then((r) => {
		if(cb != undefined) cb(r);
	});
}

export const activate_pack_trial = (product_id,cb) => {
	fetch(getRemotedbUrl(`/v24/pack/activate_trial/${product_id}`)).then((r) => r.json()).then((r) => {
		if(cb != undefined) cb(r);
	});
}